<template>
  <b-table hover striped show-empty responsive :items="visas" :fields="fields" no-border-collapse outlined
    class="table-container" head-variant="light">
    <template #cell(id)="data">
      <span class="typo-color-blue cursor-pointer">
        <a
          :href="fetchLegacyUrl(`/visas/${data.item.id}`)"
          target="_blank"
        >
          {{ data.item.id }}
        </a>
      </span>
    </template>
    <template #cell(request)="data">
      <div>
        <span class="text-muted">Requested?</span>
        <span>{{ checkBoolean(data.item.visa_assistance) }}</span>
      </div>
    </template>
    <template #cell(program)="data">
      <span>
        {{ data.item.program }}
      </span>
    </template>
    <template #cell(updated_at)="data">
      <span v-if="data.item.updated_at" class="text-nowrap">{{moment(data.item.updated_at, 'YYYY-MM-DD HH:mm:ss').format('MMM Do, YYYY hh:mm:a')}}</span>
      <span v-else>--</span>
    </template>
  </b-table>
</template>

<script>
import mixin from "@/utils/mixin.js"

export default {
	name: "PersonProgramVisa",
	mixins: [mixin],
	props: ["visas"],
	data() {
		return {
			fields: [
				{
					key: "id",
					label: "Visa ID",
				},
				{
					key: "request",
					label: "Requested?",
				},
				{
					key: "program",
					label: "Program",
				},
				{
					key: "updated_at",
					label: "Updated",
				},
			],
		}
	},
}
</script>